export const subscriptionSets = [
  {
    "id": "167c9f28-0cd4-4902-ae18-b81529e48c96",
    "name": "сет Брюс Ли **",
    "description": "Горячий Дон жуан, Калифорния, Розовый, Кани гриль",
    "price": 0,
    "image": "/img/sets/set_bruce_lee.jpg",
    "code": 1168
  },
  {
    "id": "8a19facc-ef7b-497f-b97c-7965fbb72dbc",
    "name": "сет Гармония классики **",
    "description": "Филадельфия сливочная, Калифорния, Кани гриль, Сяке кунсей гриль",
    "price": 0,
    "image": "/img/sets/set_garmoniya.jpg",
    "code": 430
  },
  {
    "id": "123cfb8f-c53d-45dd-8ed3-fe091172ab2d",
    "name": "сет Дамский угодник **",
    "description": "Филадельфия сливочная, Сырные маки, Чикен лав, Краб дуэт гриль",
    "price": 0,
    "image": "/img/sets/set_damskiy_ugodnik.jpg",
    "code": 1169
  },
  {
    "id": "96915afe-9688-41d9-87a6-95068969b1a4",
    "name": "сет Домино **",
    "description": "Филадельфия сливочная, Манхеттен, Кани гриль, Запеченный мистер Грин",
    "price": 0,
    "image": "/img/sets/set_domino.jpg",
    "code": 1170
  },
  {
    "id": "d28f671d-59be-427c-9bc3-8df4e4b6947c",
    "name": "сет Игра престолов **",
    "description": "Дракон лайт, Филадельфия сливочная, Эби гриль, Бруклин",
    "price": 0,
    "image": "/img/sets/set_igra_prestolov.jpg",
    "code": 1172
  },
  {
    "id": "cc715582-7710-4f6e-83ec-5f0acf4402cb",
    "name": "сет Олимпия **",
    "description": "Филадельфия дуэт, Калифорния дуэт, Запеченный ролл с беконом, Чикен гриль",
    "price": 0,
    "image": "/img/sets/set_olimpiya.jpg",
    "code": 56
  },
  {
    "id": "c2d1a9ee-3a94-46ad-a776-c4514a8af22a",
    "name": "сет Жаркая осень **",
    "description": "Фила кани гриль, Сяке кани гриль, Сяке кунсей гриль",
    "price": 0,
    "image": "/img/sets/set_zharkaya_osen.jpg",
    "code": 1171
  },
  {
    "id": "77b5b674-13c7-4cb9-a1bf-182472fa3c85",
    "name": "сет Сливочный **",
    "description": "Красная Москва лайт, Манхеттен блэк, Чезария, Филадельфия лайт с огурцом",
    "price": 0,
    "image": "/img/sets/set_slivochniy.jpg",
    "code": 1173
  },
  {
    "id": "e5260852-f047-42ae-b7f3-006592073b4d",
    "name": "Тёплый лосось микс **",
    "description": "Яки сяке, Сяке хот, Сяке ясай",
    "price": 0,
    "image": "/img/sets/set_tepliy_losos.jpg",
    "code": 1175
  },
  {
    "id": "5294512a-38e0-48e8-8ae7-0676038f543c",
    "name": "Трипл сет **",
    "description": "Краб дуэт гриль, Сяке кани гриль, Запеченный Мидуэй",
    "price": 0,
    "image": "/img/sets/set_tripl.jpg",
    "code": 1176
  }
];
